import React from 'react';

import PropTypes from 'prop-types';

import { getBgClassName } from 'apps/promo/components/utils';

import styles from './TileColoredWithChild.module.css';
import { PromoButton } from '../promo-button/PromoButton';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';
import { PromoText } from '../promo-text/PromoText';

export const TileColoredWithChild = ({ bgColor = 'aubergine01', ...props }) => {
    const bgClassName = getBgClassName(bgColor);
    const containerClass = `${styles.tileContainer} ${bgClassName}`;

    return (
        <div className={containerClass}>
            {props.title && (
                <div className={styles.title}>
                    <PromoText color={'white'} tag="div" variant="h1" textAlign={'center'}>
                        {props.title}
                    </PromoText>
                </div>
            )}
            {props.subtitle && <PromoDangerouslyHtml color={'white'} dangerouslyHtml={props.subtitle} tag="div" variant={'subheader'} textAlign={'center'} />}
            {props.children}
            {(props.btnTitle || props.btnSecondaryTitle) && (
                <div className={styles.buttonContainer}>
                    {props.btnTitle && (
                        <PromoButton caption={props.btnTitle} disabled={props.disabledBtn} variant="primary" isInverted onClick={props.onButtonClick} />
                    )}
                    {props.btnSecondaryTitle && (
                        <PromoButton caption={props.btnSecondaryTitle} variant="secondary" isInverted onClick={props.onButtonSecondaryClick} />
                    )}
                </div>
            )}
            {props.note && (
                <div className={styles.note}>
                    <PromoDangerouslyHtml color={'white'} tag="div" textAlign={'center'} dangerouslyHtml={props.note} />
                </div>
            )}
        </div>
    );
};

TileColoredWithChild.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    btnTitle: PropTypes.string,
    onButtonClick: PropTypes.func,
    disabledBtn: PropTypes.bool,
    note: PropTypes.string,
    btnSecondaryTitle: PropTypes.string,
    onButtonSecondaryClick: PropTypes.func,
};
